<script setup lang="ts">
/* eslint-disable max-len */
export interface IconShareProps {
  fill?: string;
}

const props = withDefaults(defineProps<IconShareProps>(), {
  fill: "#A9B7D1",
});
</script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <clipPath id="04km5tcjpa">
        <path d="M1440 0v1882H0V0h1440z" />
      </clipPath>
      <clipPath id="pdj0yatilb">
        <!-- eslint-disable-next-line max-len -->
        <path d="M2.4 5.331c.442 0 .8.341.8.762s-.358.762-.8.762h-.8v7.62h9.6v-7.62h-.8c-.442 0-.8-.34-.8-.762 0-.42.358-.762.8-.762h.8c.884 0 1.6.683 1.6 1.524v7.62c0 .843-.716 1.525-1.6 1.525H1.6C.716 16 0 15.318 0 14.476v-7.62C0 6.013.716 5.33 1.6 5.33h.8zM6.966.223 9.228 2.38a.737.737 0 0 1 0 1.077.828.828 0 0 1-1.131 0L7.2 2.602v6.54c0 .42-.358.762-.8.762-.442 0-.8-.342-.8-.762v-6.54l-.897.854a.828.828 0 0 1-1.131 0 .737.737 0 0 1 0-1.077L5.834.223a.829.829 0 0 1 1.132 0z" />
      </clipPath>
    </defs>
    <g clip-path="url(#04km5tcjpa)" transform="translate(-716 -711)">
      <g clip-path="url(#pdj0yatilb)" transform="translate(717.6 711)">
        <path :fill="props.fill" d="M0 0h12.8v16H0V0z" />
      </g>
    </g>
  </svg>
</template>
